import Column from '@components/column'
import Title from '@components/title'
import React, { Fragment } from 'react'
import Banner from './banner-form'
import Tab from '@components/tabs'
import ScreenshotReference from './screenshot-reference'

const BannerSettings = () => {
  const items = [
    { label: 'Banner List', component: Banner },
    { label: 'Screenshot References', component: ScreenshotReference },
  ]
  return (
    <Fragment>
      <Column>
        <Title textone="Banner" texttwo="Settings" />
        <Tab items={items} />
      </Column>
    </Fragment>
  )
}

export default BannerSettings
